// extracted by mini-css-extract-plugin
export default {"greyBg":"src-modules-page-style__greyBg_30ebd"};